import { Filter, FilterObj } from '@kentik/ui-shared/filters/types';

/**
 * Traverse filterGroups to get all the filter fields as an array
 * Optionally set `includeFilterValue` to true for an array of `{filterField:filterValue}` objects
 */
export function getFilterFields(groups: FilterObj[], includeFilterValue?: boolean) {
  const filterFields = new Set<Filter | string>();

  if (Array.isArray(groups)) {
    groups
      .filter((group) => group)
      .forEach((group) => {
        if (Array.isArray(group.filters)) {
          group.filters
            .filter((filter) => filter)
            .forEach((filter) => {
              if (includeFilterValue) {
                const { filterField, filterValue } = filter;
                filterFields.add({ filterField, filterValue });
              } else {
                filterFields.add(filter.filterField);
              }
            });

          getFilterFields(group.filterGroups || [], includeFilterValue)
            .filter((filter) => filter)
            .forEach((field) => filterFields.add(field));
        }
      });
  }

  return Array.from(filterFields);
}
